import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RecentProjects.css';

const RecentProjects = () => {
  const navigate = useNavigate();

  const projects = [
     {
  id: -13,
  title: "JECRC Welcomes Vikrant Massey",
  image: "https://img.youtube.com/vi/5JrMq6z2tNg/hqdefault.jpg",
  description:
    "An actor known for his versatility, authenticity, and powerful storytelling, Vikrant represents the spirit of dreaming big and staying grounded values that define every JECRCian.",
  link: "https://youtu.be/5JrMq6z2tNg?si=fccH0IV0jZwjG5lk",
},
    {
  id: -12,
  title: 'Taarak Mehta Ka Ooltah Chashmah | Special Clip',
  image: 'https://img.youtube.com/vi/Luj6VP81SNo/hqdefault.jpg',
  description: 'A special fun moment from the iconic sitcom Taarak Mehta Ka Ooltah Chashmah.',
  link: 'https://youtu.be/Luj6VP81SNo?si=Yg_qr9iwX2xrSYGD',
},
{
  id: -11,
  title: 'Taarak Mehta Ka Ooltah Chashmah | Teaser',
  image: 'https://img.youtube.com/vi/CQh1szl8Bv4/hqdefault.jpg',
  description: 'A special teaser from the iconic show Taarak Mehta Ka Ooltah Chashmah bringing humor, drama and excitement together.',
  link: 'https://youtu.be/CQh1szl8Bv4?si=gAB2VG_E05Q8sa3m',
},
{
  id: -10,
  title: 'Jaipur me Shuru Hui | Taarak Mehta ka Ooltah Chashmah',
  image: 'https://img.youtube.com/vi/TmuuDq0jvl0/hqdefault.jpg',
  description: 'The fun begins in Jaipur as Babli prepares for the ultimate kite-cutting challenge in this entertaining moment from TMKOC.',
  link: 'https://youtu.be/TmuuDq0jvl0?si=M3rBuOttUH5JvRrI',
},
{
  id: -9,
  title: 'Babli Vs Popatlal | Taarak Mehta Ka Ooltah Chashmah',
  image: 'https://img.youtube.com/vi/6KYO4o0BSh8/hqdefault.jpg',
  description: 'A hilarious clash between Babli and Popatlal from the beloved sitcom Taarak Mehta Ka Ooltah Chashmah.',
  link: 'https://youtu.be/6KYO4o0BSh8?si=RH5QOPbhapVWg0lN',
},
{
  id: -8,
  title: 'New Holland 3230TX',
  image: 'https://img.youtube.com/vi/QSskFB14gPA/hqdefault.jpg',
  description: "हर काम में असली ताक़त दिखाता है हमारा असली साथी New Holland 3230TX।",
  link: 'https://youtu.be/QSskFB14gPA?si=JZl4oKlztGjsTmN_',
},

{
  id: -7,
  title: 'Haryana Steelers x New Holland',
  image: 'https://img.youtube.com/vi/fEc-_jRnTxY/hqdefault.jpg',
  description: "भरोसे की असली ताकत | Haryana Steelers x New Holland",
  link: 'https://youtu.be/fEc-_jRnTxY?si=K5bc_idkHi5-MuUs',
},

    {
  id: -6,
  title: 'Dabur Chyawanprash',
  image: 'https://img.youtube.com/vi/RtgoA15IdG0/hqdefault.jpg',
  description: "Which Pirate will get the last bite of #AndarSeStrong Immunity?",
  link: 'https://youtube.com/shorts/RtgoA15IdG0?si=N203Bsb3s3zp7jWk',
}, 
    {
  id: -5,
  title: 'Dabur Chyawanprash',
  image: 'https://img.youtube.com/vi/ai4V95Nm8zA/hqdefault.jpg',
  description: "Kya hai Patna Pirates ki taakat ka raaz?",
  link: 'https://youtube.com/shorts/ai4V95Nm8zA?si=L0kpFlgaN9tkQ-dg',
},  
    {
  id: -4,
  title: 'EXCLUSIVE!!',
  image: 'https://img.youtube.com/vi/EQkHBOI0gFM/hqdefault.jpg',
  description: "An exclusive, never-before-seen collaboration between Cricket Bazaar and @dotmedia.",
  link: 'https://drive.google.com/file/d/1GGnC1i6PS4nVW46OUzrEXGqHlSId1jTj/preview',
},    
    {
  id: -3,
  title: 'Cricket Bazaar Chalu Che!',
  image: 'https://img.youtube.com/vi/EQkHBOI0gFM/hqdefault.jpg',
  description: "Cricket Bazaar is your one-stop destination for everything about cricket.",
  link: 'https://www.youtube.com/watch?v=EQkHBOI0gFM',
},
    {
    id: -2,
    title: 'Luminous',
    image: 'https://img.youtube.com/vi/GtvnY0rlWH4/hqdefault.jpg',
    description: "Luminous Solar - India's only true end-to-end solar expert.",
    link: 'https://www.youtube.com/watch?v=GtvnY0rlWH4&ab_channel=LuminousIndia',
  },
    {
      id: -1,
      title: 'Luminous - Solar Experts',
      image: 'https://img.youtube.com/vi/8IkoDrYnPn8/hqdefault.jpg',
      description: 'Luminous',
      link: 'https://youtu.be/8IkoDrYnPn8?si=igqYBMiScqxDiUZL',
    },
    {
      id: 0,
      title: 'Dekha Ji Dekha Maine - New Release',
      image: 'https://img.youtube.com/vi/TJ2Um2gQ4E0/hqdefault.jpg',
      description: 'Latest T-Series release.',
      link: 'https://youtu.be/TJ2Um2gQ4E0?si=YAp2AJ94pFBKxsh5',
    },
    {
      id: 1,
      title: 'Twamev - Truly You',
      image: 'https://img.youtube.com/vi/OFiHoLAAyPw/hqdefault.jpg',
      description: 'Truly You.',
      link: 'https://youtu.be/OFiHoLAAyPw',
    },
    {
      id: 2,
      title: 'Twamev - A mix of past',
      image: 'https://img.youtube.com/vi/5TpJN-lGyPU/hqdefault.jpg',
      description: 'A mix of past.',
      link: 'https://youtu.be/5TpJN-lGyPU',
    },
    {
      id: 3,
      title: 'Twamev - I am grace',
      image: 'https://img.youtube.com/vi/KjGsKOiznPM/hqdefault.jpg',
      description: 'I am grace.',
      link: 'https://youtu.be/KjGsKOiznPM',
    },
    {
      id: 4,
      title: 'Mismatched S3 | Netflix India',
      image: 'https://img.youtube.com/vi/b87uNYutCLs/hqdefault.jpg',
      description: 'Dimple and Rishi are back again, to spread some love with your Favourite Comfort Show! Mismatched S3.',
      link: 'https://www.youtube.com/watch?v=b87uNYutCLs&ab_channel=NetflixIndia',
    },
    {
      id: 5,
      title: 'Mr. & Mrs. Mahi | Netflix India',
      image: 'https://img.youtube.com/vi/vB7OiVfmEDM/hqdefault.jpg',
      description: 'Watch Mr. & Mrs. Mahi live their dreams and not their parents’, in this heartfelt, inspiring drama.',
      link: 'https://www.youtube.com/watch?v=vB7OiVfmEDM&ab_channel=NetflixIndia',
    },
    {
      id: 6,
      title: 'Air India New Identity',
      image: 'https://img.youtube.com/vi/al51WZcN2_U/hqdefault.jpg',
      description: 'Reimagining the legacy of Air India with a fresh identity and vision.',
      link: 'https://www.youtube.com/watch?v=al51WZcN2_U&ab_channel=AirIndiaOfficial',
    },
    {
      id: 7,
      title: 'Tata Motors Cars | Built for the Bold',
      image: 'https://img.youtube.com/vi/9QFe0eELKws/hqdefault.jpg',
      description: 'Explore the bold and innovative designs of Tata Motors cars.',
      link: 'https://www.youtube.com/watch?v=9QFe0eELKws&ab_channel=TataMotorsCars',
    },
    {
      id: 8,
      title: 'Parachute Advansed | Coconut Hair Oil',
      image: 'https://img.youtube.com/vi/rJj-HQ3mJvE/hqdefault.jpg',
      description: 'Rediscover the timeless beauty of coconut hair oil with Parachute Advansed.',
      link: 'https://www.youtube.com/watch?v=rJj-HQ3mJvE&ab_channel=ParachuteAdvansed',
    },
    {
      id: 9,
      title: 'Rajasthan Tourism | Discover Rajasthan',
      image: 'https://img.youtube.com/vi/nZP9OL698as/hqdefault.jpg',
      description: 'Discover the vibrant culture and heritage of Rajasthan.',
      link: 'https://www.youtube.com/watch?v=nZP9OL698as&ab_channel=RajasthanTourism',
    },
  ];

  return (
    <section className="recent-projects">
      <div className="container">
        <h2 className="section-title">Recent Projects</h2>
        <div className="projects-grid">
          {projects.map((project) => (
            <div
              className="project-card"
              key={project.id}
              onClick={() => window.open(project.link, '_blank')}
            >
              <img src={project.image} alt={project.title} className="project-image" />
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="cta-container">
          <button className="view-all-button" onClick={() => navigate('/contact')}>
            Contact
          </button>
        </div>
      </div>
    </section>
  );
};

export default RecentProjects;
